if (!customElements.get('product-video-modal')) {
  class ProductVideoModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.pdp-video__dialog');
      this.frame = this.querySelector('.pdp-video__frame');
      this.url = this.dataset.videoUrl;
      if (!this.dialog || !this.frame || !this.url) return;

      this.querySelector('.pdp-video__open')?.addEventListener('click', () => this.open());
      this.querySelector('.pdp-video__close')?.addEventListener('click', () => this.dialog.close());
      // Close when the backdrop (the dialog element itself) is clicked.
      this.dialog.addEventListener('click', (evt) => {
        if (evt.target === this.dialog) this.dialog.close();
      });
      // Clear the embed on close so the video stops playing.
      this.dialog.addEventListener('close', () => { this.frame.innerHTML = ''; });
    }

    open() {
      this.frame.innerHTML = ProductVideoModal.embed(this.url);
      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    static embed(url) {
      const yt = url.match(/(?:youtube\.com\/.*[?&]v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{11})/);
      if (yt) {
        return `<iframe src="https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0&playsinline=1&modestbranding=1" title="Product video" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" allowfullscreen frameborder="0"></iframe>`;
      }
      const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vimeo) {
        return `<iframe src="https://player.vimeo.com/video/${vimeo[1]}?autoplay=1" title="Product video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0"></iframe>`;
      }
      return `<video src="${url}" controls autoplay playsinline></video>`;
    }
  }

  customElements.define('product-video-modal', ProductVideoModal);
}
